import { Button } from '@/Components/UI/Button/Button';
import LinkToClickhouse from '@/pages/SettingsPage/SettingsPages/LinkToClickhouse';
import { showModal } from '@/redux/reducers/modalsSlice';
import { getBaseUrl } from '@/Utils/commonUtils';
import { CHARGEBEE_SITE_PROD, CHARGEBEE_SITE_TEST, MODAL_INVITE_TEAM } from '@/Utils/constants';
import { useDispatch } from 'react-redux';
import UserSettings from '../pages/SettingsPage/SettingsPages/AccountSettings';
import SubscriptionAndUsageSettings from '../pages/SettingsPage/SettingsPages/SubscriptionAndUsageSettings';
import TeamSettings from '../pages/SettingsPage/SettingsPages/TeamSettings';

export const pageByIndex = (index) => {
  switch (index) {
    case 0:
      return <UserSettings />;
    case 1:
      return <TeamSettings />;
    case 2:
      return <SubscriptionAndUsageSettings />;
    case 3:
      return <LinkToClickhouse />;
    default:
      return <UserSettings />;
  }
};

export const InviteTeamButton = ({ styles }) => {
  const dispatch = useDispatch();
  return (
    <Button onClick={() => dispatch(showModal({ name: MODAL_INVITE_TEAM }))} {...styles}>
      Invite Team
    </Button>
  );
};

export const settingsHeader = (header) => {
  const { title, button } = header;
  return (
    <div className='w-full max-w-6xl px-16'>
      <div className='flex flex-row justify-between w-full h-20 py-6 my-12 border-b border-shadow-200'>
        <div className='text-xl font-extrabold text-ui-secondary text-[21px]'>{title}</div>
        {button}
      </div>
    </div>
  );
};

const getChargebeeSite = () => {
  const baseUrl = getBaseUrl('api');
  if (
    ['dev.gigasheet.com', 'localhost', 'dev.supergiga.co'].some((hostname) =>
      baseUrl.includes(hostname)
    )
  ) {
    return CHARGEBEE_SITE_TEST;
  } else {
    return CHARGEBEE_SITE_PROD;
  }
};

export const manageBilling = () => {
  const cbInstance = window.Chargebee?.init({
    site: getChargebeeSite(),
    isItemsModel: true,
  });
  const cbPortal = cbInstance.createChargebeePortal();
  cbPortal.open();
};

export const subscriptionPrices = {
  '0.5GB': 0,
  '1GB': 0,
  '10GB': 95,
  '25GB': 165,
  '50GB': 325,
  '100GB': 495,
  '150GB': 750,
  '200GB': 950,
};

// Function to get external_name for a subscription item of type "plan"
export function getExternalNameForPlan(subscriptionData = []) {
  for (const subscriptionObject of subscriptionData) {
    const subscriptionItems = subscriptionObject.subscription_items;
    for (const item of subscriptionItems) {
      if (item.item_type === 'plan') {
        return item.item_external_name;
      }
    }
  }
  return null; // Return null if no plan type item is found
}

// Function to get the sum of all subscription items amounts
export function getSumOfSubscriptionAmounts(subscriptionData = []) {
  let totalAmount = 0;

  for (const subscriptionObject of subscriptionData) {
    const subscriptionItems = subscriptionObject.subscription_items;
    for (const item of subscriptionItems) {
      totalAmount += item.amount;
    }
  }

  return totalAmount;
}
